import * as React from 'react';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { IPlaceHolder, IDocument, ISpread, IPage } from '../../../../../infrastructure/interfaces';
import { productType } from '../../../../../infrastructure/ProductType';
import TypeProduct from '../../../../Products/TypeProduct';
import TypeProductLegacy from './PageTypes/TypeProductLegacy';
import TypeImage from './PageTypes/TypeImage';
import TypeCropDivider from './PageTypes/TypeCropDivider';
import TypeSeedDivider from "./PageTypes/TypeSeedDivider";
import TableOfContents from './PageTypes/TableOfContents';
import BlankPage from './PageTypes/BlankPage';
import TypeSeed from 'src/components/Products/TypeSeed';
import TypeSeedAgronomy from 'src/components/Products/TypeSeedAgronomy';
import { LayoutType } from 'src/infrastructure/LayoutTypes';

export interface IPagePlaceholder {
  removeProduct?(e: any, index: number): void;
  index: number;
  model: IPlaceHolder;
  isEditorView: boolean;
  pageNumber?: number;
  document: IDocument | null;
  isAside?: boolean
}

export default class PagePlaceholder extends React.Component<IPagePlaceholder> {
  constructor(props: IPagePlaceholder) {
    super(props);
  }

  renderComponent(model: any) {
    let pageLayout: LayoutType = LayoutType.Agronomy;
    if (this.props.document) {
      this.props.document.spreads.forEach((spread: ISpread) => {
        if (this.props.pageNumber === spread.left.number) {
          pageLayout = spread.left.layout || LayoutType.FullPage;
        }
        if (spread.right && this.props.pageNumber === spread.right.number) {
          pageLayout = spread.right.layout || LayoutType.FullPage;
        }
      });
    }
    switch (model.type) {
      case placeholderTypes.Product:
      case placeholderTypes.Agronomy:
      case placeholderTypes.Seed:
        if (!model.data) {
          return '';
        }
        if (this.props.isAside && model.data.type !== 'Seed') {
          return <TypeProductLegacy product={model.data}
          pageNumber={this.props.pageNumber} />;
        }

        const isSeed: boolean = model.data.type === 'Seed';
        let isAgronomyRow: boolean = isSeed && pageLayout === LayoutType.Agronomy;
        isAgronomyRow = isAgronomyRow && !!this.props.pageNumber && this.props.pageNumber % 2 === 0; // is left page
        isAgronomyRow = isAgronomyRow && this.props.index < 16;
        isAgronomyRow = isAgronomyRow || model.type === placeholderTypes.Agronomy;

        if (isAgronomyRow) {
          // 18 seeds per page. Numer 18 is the first item on the second page, so 'first=true' 
          return <TypeSeedAgronomy product={model.data}
            pageNumber={this.props.pageNumber} zebra={this.props.index % 2 === 0 ? 'odd' : 'even'}
            first={(this.props.index === 0) || (this.props.index === 18)} last={this.props.index === this.findLastAgronomyRowIndex()} />;
        } else if (isSeed) {

          if(this.props.document) {
            return <TypeSeed product={model.data}
            pageNumber={this.props.pageNumber}
            document={this.props.document}/>;
          }

          return <TypeSeed product={model.data}
            pageNumber={this.props.pageNumber}/>;
        }

        if (this.props.document) {
          return <TypeProduct product={model.data}
                            pageNumber={this.props.pageNumber}
                            document = {this.props.document} />;
        }
        return <TypeProduct product={model.data}
                            pageNumber={this.props.pageNumber}/>;
      case placeholderTypes.Image:
      case placeholderTypes.Blank:
        return <TypeImage document={this.props.document} data={model.data} isEditorView={this.props.isEditorView} />;
      case placeholderTypes.Divider:
        return <TypeSeedDivider data={model.data} isEditorView={this.props.isEditorView} />;
      case placeholderTypes.CropDivider:
        return <TypeCropDivider data={model.data} isEditorView={this.props.isEditorView} />;
      case placeholderTypes.SeedDivider:
        return <TypeSeedDivider data={model.data} isEditorView={this.props.isEditorView} />;
      case placeholderTypes.TOC:
        return <TableOfContents data={{ pages: this.props.document!.pages }} />;
      case placeholderTypes.BlankPage:
        return <BlankPage data={{ pages: this.props.document!.pages }} />;
      default:
        const pageNumber = this.props.pageNumber;
        const currentPage = this.props.document!.pages.find(p => p.number === pageNumber);
        return currentPage && this.props.document!.type === productType.Catalog && typeof window === 'object' ?
          <div className="defaultPage">{currentPage.position}</div> : null;
    }
  }

  render() {
    const {
      index,
      model,
      isEditorView,
    } = this.props;

    return (
      <div className={"page-placeholder-container"}>
        {this.renderComponent(model)}
        {isEditorView && (this.props.removeProduct) && (model.data || (!model.data && model.type === placeholderTypes.TOC || model.type === placeholderTypes.BlankPage))
          ? <span onClick={e => this.props.removeProduct!(e, index)} className="remove"></span>
          : null}
      </div>
    );
  }

  findLastAgronomyRowIndex() {
    let index: number = -1;
    let page: IPage = {
      title: '',
      placeholders: [],
      type: 0,
      number: 0,
      position: '',
    };
    if (this.props.document) {
      this.props.document.spreads.forEach((spread: ISpread) => {
        if (this.props.pageNumber === spread.left.number) {
          page = spread.left;
        }
        if (spread.right && this.props.pageNumber === spread.right.number) {
          page = spread.right;
        }
      });
    }
    if (page) {
      page.placeholders.forEach((placeholder: IPlaceHolder, i: number) => {
        if (index < i && placeholder.data && i < 16) {
          index = i;
        }
      });
    }
    return index;
  }

}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PagePlaceholder.tsx